<div class="card card-custom">
    <div class="card-header">
        <div class="card-title">
            <h4 class="card-label">{{data.title}}</h4>
        </div>
        <div class="card-toolbar">
            <button mat-icon-button type="button" aria-label="Close" (click)="onCancel()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <div class="card-body pt-0 w-100">
        <mat-dialog-content>
            <div class="drop-area"
                 ktFileDropZone
                 [dropZoneMultiple]="multiple"
                 (filesDropped)="onFilesDropped($event)"
                 (click)="browse()">
                <mat-icon class="drop-area__icon">cloud_upload</mat-icon>
                <div class="drop-area__title">Drag &amp; drop {{multiple ? 'files' : 'a file'}} here</div>
                <div class="drop-area__subtitle">or <span class="drop-area__link">browse</span> your computer</div>
                <div class="drop-area__hint">
                    {{allowedTypesLabel}} &mdash; up to {{data.maxFileSizeMb}}mb per file
                </div>
                <input #fileInput
                       type="file"
                       [multiple]="multiple"
                       [attr.accept]="data.accept"
                       (change)="onInputChange($event)"
                       style="display: none"/>
            </div>

            <div class="selected-files" *ngIf="selectedFiles.length > 0">
                <div class="selected-files__row" *ngFor="let selected of selectedFiles; let i = index"
                     [class.selected-files__row--invalid]="selected.error">
                    <mat-icon class="selected-files__icon">insert_drive_file</mat-icon>
                    <div class="selected-files__info">
                        <div class="selected-files__name">{{selected.file.name}}</div>
                        <div class="selected-files__meta" *ngIf="!selected.error">
                            {{formatSize(selected.file.size)}}
                        </div>
                        <div class="selected-files__error" *ngIf="selected.error">
                            {{selected.error}}
                        </div>
                    </div>
                    <button mat-icon-button
                            color="warn"
                            type="button"
                            matTooltip="Remove"
                            (click)="removeFile(i)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>

            <div class="invalid-note" *ngIf="hasInvalidFiles">
                Files marked in red will not be uploaded.
            </div>
        </mat-dialog-content>
    </div>
    <div class="card-footer d-flex justify-content-end">
        <button mat-button mat-raised-button type="button" class="mr-2" (click)="onCancel()">
            Cancel
        </button>
        <button mat-button mat-raised-button
                color="primary"
                type="button"
                [disabled]="validFiles.length === 0"
                (click)="onUpload()">
            Upload {{multiple && validFiles.length > 0 ? '(' + validFiles.length + ')' : ''}}
        </button>
    </div>
</div>
